import { CreateBookingData } from "@/lib/validation/booking";

export interface BookingPayloadOptions {
  paymentMethod?: string;
  includeVehicleWeight?: boolean;
  useWalletBalance?: boolean;
}

export function buildBookingPayload(
  formData: Partial<CreateBookingData>,
  options: BookingPayloadOptions = {},
) {
  const paymentMethod =
    options.paymentMethod ?? formData.payment_method ?? "card";

  const payload = {
    ...formData,
    service_type: formData.service_type!,
    from_address: formData.from_address!,
    from_latitude: formData.from_latitude!,
    from_longitude: formData.from_longitude!,
    to_address: formData.to_address!,
    to_latitude: formData.to_latitude!,
    to_longitude: formData.to_longitude!,
    vehicle_registration: formData.vehicle_registration!,
    vehicle_category: formData.vehicle_category!,
    vehicle_body_type: formData.vehicle_body_type?.toLowerCase()!,
    vehicle_image: formData.vehicle_image || undefined,
    scheduled_at: formData.scheduled_at ?? null,
    passenger_count: formData.passenger_count || 0,
    pet_count: formData.pet_count || 0,
    questions: formData.questions || [],
    payment_method: paymentMethod,
    ...(options.useWalletBalance ? { use_wallet_balance: true } : {}),
    inspection_required: formData.inspection_required,
    inspection_tier: formData.inspection_tier,
    inspection_template_id: formData.inspection_template_id,
  };

  if (options.includeVehicleWeight && formData.vehicle_weight) {
    return {
      ...payload,
      vehicle_weight: formData.vehicle_weight,
    };
  }

  return payload;
}
